import type { RhythmMode } from "./audioVisualizerTypes";
import type { RhythmVisualMode } from "./aiHub/rhythmEngineCore";

/** 产品内置律动模式（8 种） */
export const RHYTHM_MODE_OPTIONS: ReadonlyArray<{
  label: string;
  value: RhythmMode;
}> = [
  { label: "共鸣光域", value: "classic" },
  { label: "曲率频阶", value: "curvatureFreq" },
  { label: "频谱瀑布", value: "spectrumWaterfall" },
  { label: "分频脉冲", value: "splitFreqPulse" },
  { label: "极限爆律", value: "ultraBeatStrobe" },
  { label: "波纹涟漪", value: "ripple" },
  { label: "分组闪断", value: "syncStrobe" },
  { label: "风暴漩涡", value: "vortexStorm" },
];

/** 内置模式 ID → ai-hub 律动引擎模式（频谱/布局/节拍算法） */
export const BUILTIN_RHYTHM_ENGINE_MODE: Record<RhythmMode, RhythmVisualMode> =
  {
    classic: "classicWave",
    curvatureFreq: "columnUp",
    curvatureFreqNew: "curvatureFreq",
    spectrumWaterfall: "columnUp",
    columnUpPreset: "columnUp",
    waveHumpPreset: "columnUp",
    dormantVolcano: "columnUp",
    arrowPierceHeart: "columnUp",
    twinHeartsDance: "centerSpread",
    splitFreqPulse: "splitFreq",
    ultraBeatStrobe: "beatStrobe",
    ripple: "ripple",
    syncStrobe: "mirrorFlip",
    vortexStorm: "vortex",
  };

export function isBuiltinRhythmMode(mode: string): mode is RhythmMode {
  return RHYTHM_MODE_OPTIONS.some((item) => item.value === mode);
}

export function normalizeRhythmMode(mode: string): RhythmMode {
  return isBuiltinRhythmMode(mode) ? mode : "classic";
}

export function resolveBuiltinRhythmEngineMode(mode: string): RhythmVisualMode {
  return BUILTIN_RHYTHM_ENGINE_MODE[normalizeRhythmMode(mode)];
}
